export type NavItem = {
  label: string;
  href: string;
  hideOnHome?: boolean;
};

export const NAV_ITEMS: NavItem[] = [
  { label: "Home", href: "/#home", hideOnHome: true },
  { label: "Process", href: "/#howiwork" },
  { label: "Experience", href: "/#work" },
  { label: "Projects", href: "/#projects" },
  { label: "Expertise", href: "/#expertise" },
  { label: "Contact", href: "/#contact" },
];
